<template>
	<div class="nav">
		<!--大屏幕-->
		<el-menu :default-active="curActiveIndex" class="navMenu el-menu-demo" mode="horizontal" active-text-color="#253b55">
			<el-menu-item index="0" class="menuLogo">
				<a href="index.html">
					<el-image class="navLogoImg" :src="baseImgUrl + logoImg"></el-image>
				</a>
			</el-menu-item>
			<div class="flex-grow" />
			<el-menu-item index="1"><a class="aLevelOne" href="index.html">网站首页</a></el-menu-item>
			<el-submenu index="2">
				<template slot="title">关于我们</template>
				<el-menu-item index="2-1"><a class="aLevelTwo" href="about.html#/intro">公司简介</a></el-menu-item>
				<el-submenu index="2-2">
					<template slot="title"><div class="tit">组织架构</div></template>
					<el-menu-item index="2-6-1"><a class="aLevelThree" href="about.html#/org/frame">公司架构</a></el-menu-item>
					<el-menu-item index="2-6-2"><a class="aLevelThree" href="about.html#/org/leader">领导能力</a></el-menu-item>
				</el-submenu>
				<el-menu-item index="2-4"><a class="aLevelTwo" href="about.html#/business">主营业务</a></el-menu-item>
				<el-menu-item index="2-5"><a class="aLevelTwo" href="about.html#/honor">资质荣誉</a></el-menu-item>
				<el-submenu index="2-6">
					<template slot="title"><div class="tit">企业文化</div></template>
					<el-menu-item index="2-6-1"><a class="aLevelThree" href="about.html#/culture/slogan">公司口号</a></el-menu-item>
					<el-menu-item index="2-6-2"><a class="aLevelThree" href="about.html#/culture/staff">员工风采</a></el-menu-item>
					<el-menu-item index="2-6-3"><a class="aLevelThree" href="about.html#/culture/office">公司环境</a></el-menu-item>
					<el-menu-item index="2-6-4"><a class="aLevelThree" href="about.html#/culture/video">视频锦集</a></el-menu-item>
				</el-submenu>
				<el-submenu index="2-7">
					<template slot="title"><div class="tit">分支机构</div></template>
					<el-menu-item index="2-7-1"><a class="aLevelThree" href="about.html#/branch/singapore">新加坡公司</a></el-menu-item>
					<el-menu-item index="2-7-2"><a class="aLevelThree" href="about.html#/branch/maritime">环球海事</a></el-menu-item>
					<el-menu-item index="2-7-3"><a class="aLevelThree" href="about.html#/branch/equip">环球装备</a></el-menu-item>
				</el-submenu>
			</el-submenu>
			<el-submenu index="3">
				<template slot="title">公司资源</template>
				<el-menu-item index="3-1"><a class="aLevelTwo" href="resource.html#/ship">船舶资源</a></el-menu-item>
				<el-menu-item index="3-2"><a class="aLevelTwo" href="resource.html#/equip">装备资源</a></el-menu-item>
			</el-submenu>
			<el-submenu index="4">
				<template slot="title">业绩展示</template>
				<el-menu-item index="4-1"><a class="aLevelTwo" href="perform.html#/oil">海洋油气工程</a></el-menu-item>
				<el-menu-item index="4-2"><a class="aLevelTwo" href="perform.html#/wind">海洋风电工程</a></el-menu-item>
				<el-menu-item index="4-3"><a class="aLevelTwo" href="perform.html#/cable">电缆敷设与维修工程</a></el-menu-item>
				<el-menu-item index="4-4"><a class="aLevelTwo" href="perform.html#/lease">船舶租赁业务</a></el-menu-item>
				<el-menu-item index="4-5"><a class="aLevelTwo" href="perform.html#/other">其他</a></el-menu-item>
			</el-submenu>
			<el-menu-item index="5"><a class="aLevelOne" href="news.html">新闻资讯</a></el-menu-item>
			<el-menu-item index="6"><a class="aLevelOne" href="recruit.html">人才招聘</a></el-menu-item>
			<el-menu-item index="7"><a class="aLevelOne" href="contact.html">联系我们</a></el-menu-item>
			<el-submenu index="8">
				<template slot="title">EN</template>
				<el-menu-item index="8-1"><a class="aLevelTwo" href="index.html">简体中文</a></el-menu-item>
				<el-menu-item index="8-2"><a class="aLevelTwo" href="http://ds-global.cn/en/index.html">English</a></el-menu-item>
			</el-submenu>
		</el-menu>

		<!--小屏幕-->
		<div class="navMenuSmallCon">
			<div class="navMenuSmallHead">
				<el-image class="navMenuSmallLogoImg" :src="baseImgUrl + logoImg" @click="toIndex"></el-image>
				<el-link class="navMenuSmallBtn" icon="el-icon-menu" :underline="false" @click="showNavMenuSmall = !showNavMenuSmall"></el-link>
			</div>
			<el-drawer class="navMenuSmall" size="70%" title="导航" :append-to-body="false" :visible.sync="showNavMenuSmall">
				<el-menu :default-active="curActiveIndex" class="el-menu-vertical-demo">
					<el-menu-item index="1"><span class="spanLevelOne" @click="toPage('index.html')">网站首页</span></el-menu-item>
					<el-submenu index="2">
						<template slot="title">关于我们</template>
						<el-menu-item index="2-1"><span class="spanLevelTwo" @click="toPage('about.html#/intro')">公司简介</span></el-menu-item>

						<el-submenu index="2-2">
							<template slot="title"><div class="spanTit">组织架构</div></template>
							<el-menu-item index="2-6-1"><a class="spanLevelThree" @click="toPage('about.html#/org/frame')">公司架构</a></el-menu-item>
							<el-menu-item index="2-6-2"><a class="spanLevelThree" @click="toPage('about.html#/org/leader')">领导能力</a></el-menu-item>
						</el-submenu>

						<el-menu-item index="2-4"><span class="spanLevelTwo" @click="toPage('about.html#/business')">主营业务</span></el-menu-item>
						<el-menu-item index="2-5"><span class="spanLevelTwo" @click="toPage('about.html#/honor')">资质荣誉</span></el-menu-item>
						<el-submenu index="2-6">
							<template slot="title"><div class="spanTit">企业文化</div></template>
							<el-menu-item index="2-6-1"><span class="spanLevelThree" @click="toPage('about.html#/culture/slogan')">公司口号</span></el-menu-item>
							<el-menu-item index="2-6-2"><span class="spanLevelThree" @click="toPage('about.html#/culture/staff')">员工风采</span></el-menu-item>
							<el-menu-item index="2-6-3"><span class="spanLevelThree" @click="toPage('about.html#/culture/office')">公司环境</span></el-menu-item>
							<el-menu-item index="2-6-4"><span class="spanLevelThree" @click="toPage('about.html#/culture/video')">视频锦集</span></el-menu-item>
						</el-submenu>
						<el-submenu index="2-7">
							<template slot="title"><div class="spanTit">分支机构</div></template>
							<el-menu-item index="2-7-1"><span class="spanLevelThree" @click="toPage('about.html#/branch/singapore')">新加坡公司</span></el-menu-item>
							<el-menu-item index="2-7-2"><span class="spanLevelThree" @click="toPage('about.html#/branch/maritime')">环球海事</span></el-menu-item>
							<el-menu-item index="2-7-3"><span class="spanLevelThree" @click="toPage('about.html#/branch/equip')">环球装备</span></el-menu-item>
						</el-submenu>
					</el-submenu>
					<el-submenu index="3">
						<template slot="title">公司资源</template>
						<el-menu-item index="3-1"><span class="spanLevelTwo" @click="toPage('resource.html#/ship')">船舶资源</span></el-menu-item>
						<el-menu-item index="3-2"><span class="spanLevelTwo" @click="toPage('resource.html#/equip')">装备资源</span></el-menu-item>
					</el-submenu>
					<el-submenu index="4">
						<template slot="title">业绩展示</template>
						<el-menu-item index="4-1"><span class="spanLevelTwo" @click="toPage('perform.html#/oil')">海洋油气工程</span></el-menu-item>
						<el-menu-item index="4-2"><span class="spanLevelTwo" @click="toPage('perform.html#/wind')">海洋风电工程</span></el-menu-item>
						<el-menu-item index="4-3"><span class="spanLevelTwo" @click="toPage('perform.html#/cable')">电缆敷设与维修工程</span></el-menu-item>
						<el-menu-item index="4-4"><span class="spanLevelTwo" @click="toPage('perform.html#/lease')">船舶租赁业务</span></el-menu-item>
						<el-menu-item index="4-5"><span class="spanLevelTwo" @click="toPage('perform.html#/other')">其他</span></el-menu-item>
					</el-submenu>
					<el-menu-item index="5"><span class="spanLevelOne" @click="toPage('news.html')">新闻资讯</span></el-menu-item>
					<el-menu-item index="6"><span class="spanLevelOne" @click="toPage('recruit.html')">人才招聘</span></el-menu-item>
					<el-menu-item index="7"><span class="spanLevelOne" @click="toPage('contact.html')">联系我们</span></el-menu-item>
					<el-submenu index="8">
						<template slot="title">EN</template>
						<el-menu-item index="8-1"><span class="spanLevelTwo" @click="toPage('index.html')">简体中文</span></el-menu-item>
						<el-menu-item index="8-2"><span class="spanLevelTwo" @click="toPage('http://ds-global.cn/en/index.html')">English</span></el-menu-item>
					</el-submenu>
				</el-menu>
			</el-drawer>
		</div>
	</div>
</template>

<script>
export default {
	name: "NavMenu",
	props:[
		'activeIndex'
	],
	data() {
		return{
			baseImgUrl: process.env.VUE_APP_IMGURL,
			curActiveIndex: this.activeIndex,
			showNavMenuSmall: false,
			logoImg: 'assets/navMenu/logo.png'
		}
	},
	methods: {
		toIndex(){
			location.href = 'index.html';
		},
		toPage(page){
			this.showNavMenuSmall = false;
			location.href = page;
		}
	}
}
</script>
<style scoped>
	.nav, a, .spanTit, .tit{ font-family: 'SiYuan-Light', sans-serif; }
	::v-deep .el-menu{ border-bottom: 0 !important;}
	a{ color: #bababa; text-decoration: none; transition: all 0.2s linear; display: block; }
	.aLevelOne:hover{ color: #4773a3 !important; }
	.aLevelTwo:hover, .aLevelThree:hover{ color: #ffffff; background-color: #4773a3; letter-spacing: 3px; padding-left: 6px; }
	@media (max-width: 726px){
		.nav, a, .spanTit, .tit{ font-family: 'SiYuan-ExtraLight',sans-serif; }
		.navMenu{ display: none; }
		.navMenuSmallHead{ height: 88px; line-height: 88px; width: 100%; display: flex; justify-content: space-between; position: fixed; top: 0; background-color: #ffffff; z-index: 999; box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04); }
		.navMenuSmallLogoImg{ height: 52px; width: 184px; padding: 18px 0 0 8px; }
		.navMenuSmallBtn{ height: 52px; width: 52px; font-size: 20px; }
		.navMenuSmall{ font-size: 14px; }
		::v-deep .el-menu-demo .el-menu-item, ::v-deep .el-menu-demo .el-submenu__title{
			font-size: 14px; padding: 0; line-height: 40px; height: 40px; transition: all 0.2s linear; }
		.tit{ color: #354f6d; transition: all 0.25s linear; display: block; }
		.tit:hover{ color: #ffffff; background-color: #4773a3; letter-spacing: 2px; padding-left: 5px; }
		.aLevelTwo, .aLevelThree, .tit{ font-size: 14px; }
		span{ display: block; width: 100%; height: 100%; }
	}
	@media (min-width: 726px) and (max-width: 781px){
		.navMenuSmallCon{ display: none; }
		.nav{ height: 98px; width: 100%; position: fixed; top: 0; z-index: 998; box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04); }
		.navMenu{ height: 98px; line-height: 98px; width: 100%; display: flex; justify-content: space-between; }
		.menuLogo{ width: 192px !important; text-align: center; }
		.navLogoImg{ height: 48px; width: 158px; }
		.flex-grow{ flex-grow: 1; }
		::v-deep .el-menu-demo .el-menu-item, ::v-deep .el-menu-demo .el-submenu__title{
			height: 98px !important; line-height: 98px !important; font-size: 12px; text-align: center; transition: all 0.2s linear; padding: 0; width: 76px; margin-right: 2px; }
		::v-deep .el-menu-demo .el-menu-item:hover, ::v-deep .el-menu-demo .el-submenu__title:hover{
			border-bottom: 3px solid #354f6d !important; }
		.tit{ color: #354f6d; transition: all 0.25s linear; display: block; }
		.tit:hover{ color: #ffffff; background-color: #4773a3; letter-spacing: 2px; padding-left: 5px; }
		.aLevelTwo, .aLevelThree, .tit{ font-size: 12px; }
	}
	@media (min-width: 781px) and (max-width: 999px){
		.navMenuSmallCon{ display: none; }
		.nav{ height: 98px; width: 100%; position: fixed; top: 0; z-index: 998; box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04); }
		.navMenu{ height: 98px; line-height: 98px; width: 100%; display: flex; justify-content: space-between; }
		.menuLogo{ width: 192px !important; text-align: center; }
		.navLogoImg{ height: 48px; width: 158px; }
		.flex-grow{ flex-grow: 1; }
		::v-deep .el-menu-demo .el-menu-item, ::v-deep .el-menu-demo .el-submenu__title{
			height: 98px !important; line-height: 98px !important; font-size: 12px; text-align: center; transition: all 0.2s linear; padding: 0; width: 76px; margin-right: 2px; }
		::v-deep .el-menu-demo .el-menu-item:hover, ::v-deep .el-menu-demo .el-submenu__title:hover{
			border-bottom: 3px solid #354f6d !important; }
		.tit{ color: #354f6d; transition: all 0.25s linear; display: block; }
		.tit:hover{ color: #ffffff; background-color: #4773a3; letter-spacing: 2px; padding-left: 5px; }
		.aLevelTwo, .aLevelThree, .tit{ font-size: 12px; }
	}
	@media (min-width: 999px) and (max-width: 1251px){
		.navMenuSmallCon{ display: none; }
		.nav{ height: 98px; width: 100%; position: fixed; top: 0; z-index: 998; box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04); }
		.navMenu{ height: 98px; line-height: 98px; width: 100%; display: flex; justify-content: space-between; }
		.menuLogo{ width: 270px !important; text-align: center; }
		.navLogoImg{ height: 58px; width: 202px; }
		.flex-grow{ flex-grow: 1; }
		::v-deep .el-menu-demo .el-menu-item, ::v-deep .el-menu-demo .el-submenu__title{
			height: 98px !important; line-height: 98px !important; font-size: 15px; text-align: center; transition: all 0.2s linear; padding: 0; width: 92px; margin-right: 4px; }
		::v-deep .el-menu-demo .el-menu-item:hover, ::v-deep .el-menu-demo .el-submenu__title:hover{
			border-bottom: 3px solid #354f6d !important; }
		.tit{ color: #354f6d; transition: all 0.25s linear; display: block; }
		.tit:hover{ color: #ffffff; background-color: #4773a3; letter-spacing: 2px; padding-left: 5px; }
		.aLevelTwo, .aLevelThree, .tit{ font-size: 14px; }
	}
	@media (min-width: 1252px) and (max-width: 1759px){
		.navMenuSmallCon{ display: none; }
		.nav{ height: 98px; width: 100%; position: fixed; top: 0; z-index: 998; box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04); }
		.navMenu{ height: 98px; line-height: 98px; width: 100%; display: flex; justify-content: space-between; }
		.menuLogo{ width: 328px !important; text-align: center; }
		.navLogoImg{ height: 72px; width: 262px; }
		.flex-grow{ flex-grow: 1; }
		::v-deep .el-menu-demo .el-menu-item, ::v-deep .el-menu-demo .el-submenu__title{
			height: 98px !important; line-height: 98px !important; font-size: 16px; text-align: center; transition: all 0.2s linear; padding: 0; width: 120px; margin-right: 5px; }
		::v-deep .el-menu-demo .el-menu-item:hover, ::v-deep .el-menu-demo .el-submenu__title:hover{
			border-bottom: 3px solid #354f6d !important; }
		.tit{ color: #354f6d; transition: all 0.25s linear; display: block; }
		.tit:hover{ color: #ffffff; background-color: #4773a3; letter-spacing: 2px; padding-left: 5px; }
		.aLevelTwo, .aLevelThree, .tit{ font-size: 15px; }
	}
	@media (min-width: 1760px) and (max-width: 2200px){
		.navMenuSmallCon{ display: none; }
		.nav{ height: 98px; width: 100%; position: fixed; top: 0; z-index: 998; box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04); }
		.navMenu{ height: 98px; line-height: 98px; width: 100%; display: flex; justify-content: space-between; }
		.menuLogo{ width: 380px !important; text-align: center; }
		.navLogoImg{ height: 78px; width: 277px; }
		.flex-grow{ flex-grow: 1; }
		::v-deep .el-menu-demo .el-menu-item, ::v-deep .el-menu-demo .el-submenu__title{
			height: 98px !important; line-height: 98px !important; font-size: 17px; text-align: center; transition: all 0.2s linear; padding: 0; width: 150px; margin-right: 5px; }
		::v-deep .el-menu-demo .el-menu-item:hover, ::v-deep .el-menu-demo .el-submenu__title:hover{
			border-bottom: 3px solid #354f6d !important; }
		.tit{ color: #354f6d; transition: all 0.25s linear; display: block; }
		.tit:hover{ color: #ffffff; background-color: #4773a3; letter-spacing: 2px; padding-left: 5px; }
		.aLevelTwo, .aLevelThree, .tit{ font-size: 15px; }
	}
	@media (min-width: 2201px){
		.navMenuSmallCon{ display: none; }
		.nav{ height: 98px; width: 100%; position: fixed; top: 0; z-index: 998; box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04); }
		.navMenu{ height: 98px; line-height: 98px; width: 100%; display: flex; justify-content: space-between; }
		.menuLogo{ width: 422px !important; text-align: center; }
		.navLogoImg{ height: 82px; width: 284px; }
		.flex-grow{ flex-grow: 1; }
		::v-deep .el-menu-demo .el-menu-item, ::v-deep .el-menu-demo .el-submenu__title{
			height: 98px !important; line-height: 98px !important; font-size: 18px; text-align: center; transition: all 0.2s linear; padding: 0; width: 185px; margin-right: 15px; }
		::v-deep .el-menu-demo .el-menu-item:hover, ::v-deep .el-menu-demo .el-submenu__title:hover{
			border-bottom: 3px solid #354f6d !important; }
		.tit{ color: #354f6d; transition: all 0.25s linear; display: block; }
		.tit:hover{ color: #ffffff; background-color: #4773a3; letter-spacing: 2px; padding-left: 5px; }
		.aLevelTwo, .aLevelThree, .tit{ font-size: 15px; }
	}
</style>